import React from 'react';
import styled from 'styled-components';
import Play from '../assets/play-big.svg';
import Stop from '../assets/stop.svg';
import media from '../style/media';
import Spinner from './Spinner';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
`;

const Button = styled.button<{ isMeasuring: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  background: ${({ isMeasuring }) =>
    isMeasuring
      ? 'linear-gradient(135deg, #ef4444 0%, #991b1b 100%)'
      : 'linear-gradient(135deg, #10b981 0%, #059669 100%)'};
  border: none;
  border-radius: 100px;
  cursor: pointer;
  height: 64px;
  padding: 0 48px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      120deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    transition: all 0.6s;
  }

  &:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 20px 30px -10px ${({ isMeasuring }) =>
    isMeasuring ? 'rgba(239, 68, 68, 0.4)' : 'rgba(16, 185, 129, 0.4)'};
    
    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(-2px) scale(0.98);
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: white;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const Label = styled.span`
  color: white;
  font-size: 1.125rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

export interface IStartButton {
  isLoading: boolean;
  onClick: () => void;
  isMeasuring: boolean;
}

const StartButton = ({ isLoading, onClick, isMeasuring }: IStartButton) => {
  return (
    <Container>
      {isLoading ? (
        <Spinner />
      ) : (
        <Button onClick={onClick} isMeasuring={isMeasuring}>
          <Label>{isMeasuring ? 'Stop Assessment' : 'Start Assessment'}</Label>
        </Button>
      )}
    </Container>
  );
};


export default StartButton;
